import { ApiError } from '@lib/api/api-response';

export const FLOW_DOCUMENT_PROCESSING_RETRY_STILL_PROCESSING_MESSAGE =
  'Field detection is still running in the background. Keep editing, or wait a moment and try Re-run field detection again.';

export const FLOW_DOCUMENT_PROCESSING_RETRY_GENERIC_ERROR_MESSAGE =
  'Could not re-run field detection. Please try again.';

export interface ApplyFlowDocumentProcessingRetryErrorInput {
  error: unknown;
  toastError: (message: string) => void;
  onStillProcessing?: () => void;
}

function readHttpStatus(error: unknown): number | undefined {
  if (
    error != null &&
    typeof error === 'object' &&
    'status' in error &&
    typeof (error as { status: unknown }).status === 'number'
  ) {
    return (error as { status: number }).status;
  }
  return undefined;
}

/** Shared catch path for retry-processing (409 still-processing vs generic errors). */
export function applyFlowDocumentProcessingRetryError(
  input: ApplyFlowDocumentProcessingRetryErrorInput
): void {
  const status = readHttpStatus(input.error);
  if (status === 409) {
    if (input.onStillProcessing) {
      input.onStillProcessing();
      return;
    }
    input.toastError(FLOW_DOCUMENT_PROCESSING_RETRY_STILL_PROCESSING_MESSAGE);
    return;
  }

  if (input.error instanceof ApiError) {
    input.toastError(input.error.message);
    return;
  }

  input.toastError(FLOW_DOCUMENT_PROCESSING_RETRY_GENERIC_ERROR_MESSAGE);
}
